export default "__VITE_ASSET__ykADGXoB__"